const zhCN = {
  gate: {
    title: '使用编辑器前请先登录',
    hint: '已为你打开登录窗口；也可点击右上角账户图标重新打开。',
  },
  editorDraft: {
    dialogTitle: '检测到未保存的本地草稿',
    dialogHint:
      '上次编辑的工程仍缓存在本机浏览器。可恢复继续编辑，或丢弃并以当前空白工程开始。（屏幕贴图等二进制资源需重新上传。）',
    restore: '恢复草稿',
    discard: '丢弃',
    timeHint: '保存时间：{time}',
    restoredStub: '已从本地草稿恢复工程。',
    persistFailedTitle: '本地草稿写入已暂停',
    persistFailedBody:
      '浏览器存储配额可能已满。请尽快使用「保存项目」导出 JSON，或清理本站数据后重试。',
  },
  nav: {
    home: '主页',
    projects: '项目',
    undo: '撤销',
    redo: '重做',
    accountEntry: '账户入口',
    marketingHome: '主页',
    marketingTemplates: '模板',
    marketingTutorials: '教程',
    marketingPricing: '定价',
    marketingContact: '联系我们',
    marketingConsult: '咨询',
    lang: '切换语言',
    mode: '切换工作模式',
    modeDefault: '默认模式',
    modeEdit: '编辑模式',
  },
  leftRail: {
    deviceLibrary: '设备库',
    mockupType: 'Mockup 类型',
    mockupCategory: 'Mockup 分类',
    searchDevices: '搜索设备',
    addSelected: '将所选设备添加到画布',
    add: '添加',
    editTemplate: '编辑模板',
    categoryPhone: '手机',
    categoryTablet: '平板',
    categoryLaptop: '笔记本',
    categoryWatch: '手表',
    categoryOther: '其他',
    tagImageVideo: '图片 / 视频',
    tagText: '文字',
  },
  floatingTools: {
    toolbarAria: '模型变换工具',
    moveAria: '移动当前模型',
    rotateAria: '旋转当前模型',
    scaleAria: '缩放当前模型',
    moveTitle: '移动',
    rotateTitle: '旋转',
    scaleTitle: '缩放',
  },
  viewport: {
    ariaLabel: 'Three.js 视口',
  },
  brand: {
    logoAria: 'Animock',
  },
  timeline: {
    panelLabel: '动画时间轴',
    addAnimation: '添加动画',
    scaleControl: '时间轴缩放控制',
    zoomOut: '缩小时间轴',
    zoomIn: '放大时间轴',
    zoomSlider: '时间轴缩放：最小为整段适配；最大约每秒 300 像素且刻度为秒级',
    play: '播放',
    pause: '暂停',
    current: '当前',
    seconds: '秒',
    time: '时长',
    totalTimelineSeconds: '时间轴总秒数',
    snap: '吸附',
    snapHint: '片段拖拽吸附秒数；0 表示关闭',
    list: '列表',
    tracks: '时间轴',
    layersAria: '动画图层',
    layerListAria: '动画图层列表',
    empty: '暂无模型',
    layerSelected: '{name}，已选中',
    layerSelect: '选择图层 {name}',
    addAnimationLocked: '图层已锁定，无法新增动画片段',
    addAnimationOutOfVisibility: '播放头不在可见区间内，无法新增动画片段',
    lockLayer: '锁定图层',
    unlockLayer: '解锁图层',
    duplicateLayer: '复制图层',
  },
  timelineTracks: {
    groupLabel: '时间轴轨道；聚焦后可用方向键微调播放头',
    laneAria: '{name} 的动画轨道',
    trimStart: '修剪片段起点',
    trimEnd: '修剪片段终点',
    visibilityStart: '调整可见区间起点',
    visibilityEnd: '调整可见区间终点',
    keyframeInClip: '片段内 {seconds} 秒',
    emptyLane: '添加一个 Mockup 后即可编辑动画',
    playheadAria: '播放头；拖动可快进',
  },
  lightingDock: {
    panelAria: '灯光与环境',
    title: '环境光',
    presetsAria: '灯光环境预设',
    presetAria: '灯光：{label}',
    ambientStrength: '环境光强度',
    ambientValue: '环境光倍率 {value}',
  },
  inspectorPanel: {
    inspectorAria: '检查器',
    tabsAria: '检查器标签',
    tabBasic: '基础信息',
    tabControls: 'Mockup 控制',
  },
  inspectorScene: {
    title: '场景设置',
    description:
      '上方宽高为预览画布（中间视口）。分辨率档与比例档两套并存：各自组内单选，但互不改写对方的选中项。',
    previewDimsAria: '预览画布尺寸',
    width: '宽度',
    height: '高度',
    resolutionPresets: '分辨率预设',
    resolutionHint: '仅影响导出图/视频像素；不会改变下方比例选中。当前导出约 {width}×{height}。',
    resolution4kLifetimeOnly: '仅终身会员可选择 4K 分辨率。',
    resolutionGroupAria: '分辨率预设',
    ratioPresets: '比例预设',
    ratioHint: '决定预览画布比例与逻辑像素；不会改变上方分辨率选中。导出尺寸由当前分辨率档和比例共同决定。',
    ratioGroupAria: '比例预设',
  },
  inspectorBackground: {
    title: '背景颜色',
    type: '类型',
    modeColor: '纯色',
    modeGradient: '渐变色',
    modeTransparent: '透明',
    modeImage: '图片',
    hexColor: '十六进制颜色',
    pickBackgroundColor: '选择背景颜色',
    colorPresets: '颜色预设',
    solidPresetAria: '纯色预设 {value}',
    transparentHint: '透明背景在视口中使用棋盘格显示。',
    imageHint: '上传 1 张图片作为背景（自动居中并铺满视口）。',
    imagePick: '选择图片',
    imageReplace: '替换图片',
    imageClear: '清除',
    imageInvalidType: '仅支持图片文件（PNG / JPG / WEBP 等）。',
  },
  inspectorGradient: {
    templatesAria: '渐变模板',
    fallbackTemplateName: '渐变 {id}',
    customGradient: '自定义渐变',
    colorStopsAria: '渐变色标',
    stopColorAria: '色标 {position}% 的颜色',
    stopHexAria: '色标 {position}% 的十六进制值',
    stopPositionAria: '{hex} 的位置',
    removeStopAria: '删除色标 {hex}',
    addColor: '添加颜色',
  },
  inspectorExport: {
    title: '导出设置',
    frameRate: '帧率',
    exportFormat: '导出格式',
    operation: '导出操作',
    exportImage: '导出图片',
    exportVideo: '导出视频',
    cancelExport: '取消导出',
    videoMp4TransparentBlocked:
      '透明背景无法导出 MP4（H.264 不含 Alpha）。请将格式切换为 WebM 后再导出。',
    mp4UnsupportedTitle: '当前浏览器环境暂不支持 2K MP4 导出',
    mp4UnsupportedBody:
      '你的浏览器、系统或显卡环境暂时无法完成该分辨率下的 H.264 MP4 编码。\n\n你可以尝试：\n1. 降低为 1K MP4 导出；\n2. 保持 2K 分辨率，改用 WebM 导出；\n3. 使用 Chrome / Edge 最新版本后重试。',
    vp9AlphaLayerTitle: '无法导出透明视频',
    vp9AlphaLayerBody:
      '当前浏览器不支持 WebM VP9 alpha 编码。请取消透明背景，或改用 Chrome / Edge 等浏览器后再试。',
    layerToastDismissAria: '关闭提示',
    loginRequired: '请先登录后再导出。',
    preflightInProgress: '正在登记导出，请稍候…',
    preflightFailed: '导出登记失败：{reason}',
    preflightToastTitle: '导出登记失败',
    preflightToastBody:
      '{reason}\n\n请打开「Mockup / 图层」面板：确认每个设备图层的可见时间窗覆盖当前导出时刻，图层未被锁定，且设备模板有效后再试。',
  },
  inspectorProject: {
    title: '项目操作',
    save: '保存项目',
    load: '加载项目',
    reset: '重置项目',
  },
  inspector: {
    controls: {
      panelLabel: 'Mockup 控制',
      selectionInfo: '选中信息',
      operations: 'Mockup 操作',
      pleaseSelectFirst: '请先选择一个 Mockup',
      layerName: '图层名称',
      device: '设备',
      deviceTemplateAria: '当前图层设备模板',
      position: '位置',
      rotation: '旋转 (°)',
      scale: '缩放',
      axisPosition: '位置 {axis}',
      axisRotate: '旋转 {axis}',
      axisScale: '缩放 {axis}',
      animationClip: '动画片段',
      clipEasing: '片段缓动',
      clipEasingAria: '片段缓动预设（首帧到尾帧）',
      clipHint: '每段仅首尾两帧；请在时间轴将播放头移到片段首尾或空白处再调整变换。',
      keyframesAria: '片段端点',
      firstFrame: '首帧',
      lastFrame: '尾帧',
      materialName: '材质名称',
      noMaterial: '未设置屏幕材质',
      selectMaterialFile: '选择材质文件',
      videoTextureAria: '视频屏幕纹理',
      videoFollowsTimeline: '视频跟随时间轴（自动同步）。',
      timeOffsetSec: '时间偏移（秒）',
      resetPosition: '重置位置',
      removeAnimation: '移除动画',
      removeMockup: '移除 Mockup',
      copyKeyframePose: '复制关键帧',
      pasteKeyframePose: '粘贴关键帧',
      easingLinear: '线性',
      easingEaseIn: '缓入',
      easingEaseOut: '缓出',
      easingEaseInOut: '缓入缓出',
      easingBounceOut: '弹跳结束',
      easingBackOut: '回弹结束',
      lockHint: '该图层已锁定：可删除/复制，但不可编辑属性与时间轴内容。',
      imagePlaneUpload: '选择图片 / 视频文件',
      imagePlaneHint: '上传图片或视频后，平面会自动按原始比例调整尺寸。',
      textContent: '文字内容',
      textFontSize: '字号（px）',
      textFontWeight: '字重',
      textFontWeightNormal: '常规',
      textFontWeightBold: '加粗',
      textAlign: '文字对齐',
      textAlignLeft: '左对齐',
      textAlignCenter: '居中',
      textAlignRight: '右对齐',
      textColor: '文字颜色',
      textPlaneHint: '文字使用系统默认字体，支持换行，不支持自定义字体。',
      materialOpacityLabel: '材质透明度',
      materialOpacitySliderAria: '当前关键帧材质不透明度，0 为全透明，1 为不透明',
      materialOpacityValue: '当前值：{value}',
      screenImageStackHint: '可上传多张静态图（最多 {max} 张，单边最大 {edge}px），按时间轴关键帧切换显示。',
      screenImageListAria: '屏幕图片列表',
      screenImageRemove: '删除',
      keyframeScreenImage: '此关键帧屏幕图',
      keyframeScreenImageInherit: '继承（默认首张）',
      overwriteVideoWithImagesTitle: '改用多张图片？',
      overwriteVideoWithImagesBody: '将移除当前视频并改为上传的静态图；之后可在时间轴关键帧上绑定不同图片。',
      overwriteImagesWithVideoTitle: '改用视频？',
      overwriteImagesWithVideoBody: '将清空当前所有屏幕图片并替换为所选视频。',
      screenMediaOverwriteConfirm: '继续替换',
      screenMediaOverwriteCancel: '取消',
      screenImageOversize: '图片宽或高不能超过 {max}px（当前 {w}×{h}）。',
      screenImageGifRejected: '不支持 GIF，请使用 PNG、JPEG 或 WebP。',
      screenImageLoadFailed: '无法读取该图片。',
      screenImageMaxCount: '屏幕图最多 {max} 张；当前还可添加 {room} 张。',
      screenRasterTransition: '多图切换过渡',
      screenRasterTransitionAria: '多图栈在时间轴上切换时的 GPU 过渡效果（会话偏好，下次切换生效）',
      screenRasterTransitionNone: '无过渡（瞬时）',
      screenRasterTransitionFade: '淡入淡出',
      screenRasterTransitionSlideLeft: '左滑',
      screenRasterTransitionSlideRight: '右滑',
      screenRasterTransitionSlideUp: '上滑',
      screenRasterTransitionSlideDown: '下滑',
      screenRasterTransitionZoom: '缩放',
      screenRasterTransitionCircle: '圆形展开',
    },
  },
  auth: {
    loginTab: '登录',
    registerTab: '注册',
    loginTitle: '邮箱登录',
    registerTitle: '邮箱注册',
    forgotTitle: '找回密码',
    tabsAria: '登录注册切换',
    close: '关闭登录注册弹窗',
    email: '邮箱',
    code: '验证码',
    password: '密码',
    newPassword: '新密码',
    sendCode: '获取验证码',
    submitting: '提交中...',
    submitLogin: '登录',
    submitRegister: '注册',
    submitForgot: '重置密码',
    emailInvalid: '请输入正确的邮箱地址',
    emailMissingForSendCode: '请先填写邮箱',
    codeSent: '验证码已发送，请留意邮箱',
    loginSuccess: '登录成功',
    registerSuccess: '注册成功，请直接登录',
    noAccount: '还没有账号？',
    goRegister: '注册账号',
    requestFailed: '请求失败，请稍后重试',
    sendCodeRateLimited: '操作过于频繁，请稍后再试',
    invalidCode: '验证码错误或已过期',
    emailRegistered: '该邮箱已注册',
    userNotFound: '用户不存在，请先注册',
    passwordInvalid: '密码错误',
    passwordTooShort: '密码至少 6 位',
    forgotPassword: '忘记密码',
    backToLoginPrefix: '想起密码了？',
    backToLogin: '返回登录',
    resetCodeSent: '重置验证码已发送，请留意邮箱',
    resetSuccess: '密码重置成功，请登录',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    passwordRuleHint: '建议至少 8 位，包含大小写字母、数字和特殊字符',
    strengthWeak: '弱',
    strengthMedium: '中',
    strengthStrong: '强',
    forgotStepHint: '先填写邮箱并获取验证码，然后输入新密码完成重置。',
    testFillRequired: '请填写邮箱、密码等必填项（测试模式不校验格式与真伪）',
    captchaRequired: '请先完成人机验证',
    captchaCancelled: '已取消人机验证',
    cooldownSeconds: '__N__秒',
    rememberMe: '记住密码',
    rememberDaysLabel: '免密登录',
    rememberDaysTpl: '__DAYS__ 天',
    googleDivider: '或通过以下方式继续',
    githubButton: '使用 GitHub 登录',
    wechatButton: '使用微信登录',
    wechatPopupTitle: '微信快捷登录',
    captcha: {
      title: '人机验证',
      tipPrefix: '请依次点击：',
      refresh: '换一张',
      undo: '撤销',
      confirm: '提交',
      close: '关闭人机验证',
      loading: '加载中...',
      stageAlt: '依次点击标注目标',
      loadError: '加载失败，请点击“换一张”重试',
    },
    profile: {
      title: '个人信息',
      close: '关闭个人信息',
      emailLabel: '邮箱',
      subscriptionLabel: '订阅',
      subscribed: '已订阅',
      notSubscribed: '未订阅',
      subscribeNow: '立即订阅',
      details: '详细信息',
      detailsTitle: '订阅详情',
      subscriptionSectionTitle: '订阅状态',
      ordersSectionTitle: '订单记录',
      currentTier: '当前套餐',
      expiresLabel: '到期时间',
      expiresAt: '到期：{date}',
      permanent: '永久',
      currentPeriod: '当前周期',
      nextBilling: '下次扣款',
      renewal: '续费设置',
      cancelAtPeriodEnd: '到期不续费',
      refresh: '刷新',
      loading: '加载中...',
      totalTpl: '共 {n} 条',
      emptyOrders: '暂无订单记录',
      prevPage: '上一页',
      nextPage: '下一页',
      pageTpl: '第 {p} 页',
      pagerAria: '订单分页',
      orderNoLabel: '订单号',
      payChannelLabel: '支付渠道',
      payStatusLabel: '订单状态',
      payTimeLabel: '支付时间',
      productLabel: '购买产品',
      unknown: '—',
      orderPayStatus: {
        pending: '待处理',
        pe: '支付完成',
        paid: '支付完成',
        closed: '已关闭',
        refunded: '已退款',
      },
      orderType: {
        one_time: '一次性购买',
        subscription: '订阅购买',
      },
      cancelSubscription: '关闭订阅',
      cancelling: '处理中...',
      cancelConfirmTitle: '确认关闭订阅？',
      cancelConfirmBody: '确认后将停止自动续费，当前周期内权益不受影响。',
      confirm: '确认',
      cancel: '取消',
      cancelSuccess: '订阅已更新',
      queryUnavailable: '订阅详情暂时不可用',
      proxyNonJson:
        '接口返回非 JSON（可能是 HTML 错误页）。请确认编辑器请求的 host 上存在营销站 Nitro 的 /api 代理：在生产环境设置 VITE_MARKETING_ORIGIN 为营销站完整源地址（含协议与端口）。',
      proxyHtml404:
        '订单或订阅接口返回 404 且为 HTML 页面，通常表示请求未到达营销站 Nuxt（例如仅静态 nginx）。请配置 VITE_MARKETING_ORIGIN，并确保反向代理将 /api 转发至 Node/Nitro。',
      proxyHttpError: '请求失败（HTTP {status}）',
      tier: {
        none: '未订阅',
        monthly: '月会员',
        yearly: '年会员',
        lifetime: '终身会员',
      },
      subStatus: {
        pending: '待激活',
        trialing: '试用中',
        active: '已生效',
        past_due: '扣款失败',
        paused: '已暂停',
        cancelled: '已取消',
        expired: '已过期',
        unknown: '订阅服务暂时无法访问，会员状态仍生效。点击「重新查询」可再次拉取。',
      },
      createdLabel: '注册时间',
      createdUnknown: '—',
      logout: '退出登录',
      avatarAria: '用户头像，邮箱 {email} 的首字母 {initial}',
    },
  },
  editorActions: {
    rename: '重命名',
    switchTemplate: '切换设备模板',
    editPosition: '编辑位置',
    editRotation: '编辑旋转',
    editScale: '编辑缩放',
    editScreenMaterial: '修改屏幕材质',
    resetTransform: '重置变换',
    removeClip: '删除动画片段',
    addClip: '新增动画片段',
    pasteKeyframePose: '粘贴关键帧姿态',
    editClipEasing: '修改片段缓动',
    editTimelineClip: '编辑时间轴片段',
    useViewportTransformTool: '使用视口变换工具',
    editTextContent: '修改文字内容',
    editTextFontSize: '修改文字字号',
    editTextColor: '修改文字颜色',
    editTextFontWeight: '修改文字字重',
    editTextAlign: '修改文字对齐',
    editKeyframeMaterialOpacity: '调整关键帧材质透明度',
    editKeyframeScreenImage: '绑定关键帧屏幕图',
  },
  editorMessages: {
    lockedCannot: '图层已锁定，无法{action}。',
    playheadOutsideVisibilityWindow: '播放头不在可见区间内，无法新增动画片段。',
    visibilityWindowTooShortForClip: '可见区间长度不足 1 秒，无法新增动画片段。',
    noGapInsideVisibilityWindow: '可见区间内没有足够空档添加片段（每段至少 1 秒）。',
    viewportDropNoLayerHit: '请在模型表面松开文件以替换屏幕贴图。',
    viewportDropInvalidFile: '没有可用的图片、HDR 或 MP4 文件（与属性面板接受的类型一致）。',
    viewportDropTextPlaneNotSupported: '文字图层不支持拖放屏幕贴图，请使用属性面板编辑文字。',
    screenVideoWebCodecUnsupported:
      '该视频无法用于屏幕贴图：浏览器无法解码其视频编码（常见于 MPEG-4 Part 2 等）。请将视频转为 H.264（AVC）视频轨 + AAC 音轨的 MP4 后再上传。',
  },
} as const

export default zhCN
